import { axios } from "utils";

import { ADMIN_REDZONES_URL as endpoint } from "consts";

import { RedzoneException } from "models";

export const uploadRedzones = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}`, { data });

export const getAllRedzones = async (data: { signal: AbortSignal }) => axios.get(`${endpoint}`, { data });

export const getAllRedzoneExceptions = async (data: { signal: AbortSignal }): Promise<RedzoneException[]> => axios.get(`${endpoint}/exceptions`, { data });

export const createRedzoneException = async (data: { signal: AbortSignal }) => axios.post(`${endpoint}/exceptions`, { data });

export const updateRedzoneException = async (data: { id: string; signal: AbortSignal }) => axios.put(`${endpoint}/exceptions/${data.id}`, { data });

export const confirmFieldRedzone = async (data: { fieldId: string; year: number }) => axios.put(`${endpoint}/fields/${data.fieldId}`, { data });

export const getAllFieldRedzones = async (data: { signal: AbortSignal; farmId: string }) => axios.get(`${endpoint}/fields`, { data });
